import {
    SET_AVAILABLE_CHANNELS
    } from "../actions/types";
    
    const initialState = {
      availableChannels: [],
    };
    
    export default function slackReducer(state = initialState, action) {
      switch (action.type) {
        case SET_AVAILABLE_CHANNELS:
          return {
            ...state,
            availableChannels: action.payload,
          };
        default:
          return state;
      }
    } 